import React from "react"
import {ObjectSecurityType} from "../models/response"

const formatTime = (time: number) => {
    if (time >= 0 && time < 10) return `0${time}`
    return time
}

export const getDay = (key: number) => {
    switch (key) {
        case 1:
            return 'Понедельник'
        case 2:
            return 'Вторник'
        case 3:
            return 'Среда'
        case 4:
            return 'Четверг'
        case 5:
            return 'Пятница'
        case 6:
            return 'Суббота'
        case 7:
            return 'Воскресенье'
        default:
            return 'Неизвестно'
    }
}

export const getDaysView = (days: Array<number>) => {
    const daysMap = days.map(i => <div key={i}>{getDay(i)}</div>)

    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {daysMap}
        </div>
    )
}

export const getTimeRange = (value: TimeValue) => {
    return <div>{formatTime(value.hour)}:{formatTime(value.minute)}</div>
}

export const getObjectSecurityType = (value: ObjectSecurityType) => {
    switch (value) {
        case 'GroupSchedule': return 'Расписание группы'
        case 'ObjectSchedule': return 'Расписание объекта'
        case 'Manual': return 'Вручную'
    }
}

export const securityScheduleOptions = [
    {value: '1', label: 'Постановка'},
    {value: '0', label: 'Снятие'},
]

export type TimeValue = {
    hour: number
    minute: number
}